import React from 'react';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { getBankAlias, isCardExpired } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const CardsAccountsList = (props) => {
    const { linkedCards, linkedBankAccounts, expiredLabel } = usePageMessages();

    const renderArray = (array, isAccount = true) => {
        if (array?.length > 0) {
            const title = isAccount ? linkedBankAccounts : linkedCards;
            return (
                <Row indent="48px">
                    <Row indent="24px">
                        <Text color="secondary" size="subheader">
                            {title}
                        </Text>
                    </Row>
                    {array.map((el, index) => {
                        const alias = `${el.alias} ·· ${el.description}`;
                        return (
                            <Row indent="adaptive-24-32" key={`${alias}${index}`}>
                                <Panel isBordered hasBorderRadius isHoverable onClick={(e) => props.onClickHandler(e, el, index)}>
                                    <PanelFrame>
                                        <DiskBadgeWrapper>
                                            {getBankAlias(isAccount ? el.bankLogo : el.cardLogo, isAccount ? 'bank' : 'card', isCardExpired(el))}
                                        </DiskBadgeWrapper>
                                        <PanelContent>
                                            <Text color={isCardExpired(el) ? 'lightGray' : 'primary'}>{alias}</Text>
                                        </PanelContent>
                                        {isCardExpired(el) && (
                                            <PanelRightBlock>
                                                <Badge variant="tertiary" caption={expiredLabel} />
                                            </PanelRightBlock>
                                        )}
                                    </PanelFrame>
                                </Panel>
                            </Row>
                        );
                    })}
                </Row>
            );
        }
    };

    return (
        <>
            {renderArray(props.cardsArray, false)}
            {renderArray(props.accountsArray)}
        </>
    );
};

export default CardsAccountsList;
